import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class WebinarProps {
  /**
   * Header image for the parallax scrolled
   */
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];

  /**
   * Title of the webinar
   */
  @Inlet(Accepts.String) public title?: string;

  /**
   * The date on which the webinar starts
   */
  @Inlet(Accepts.Date) public date?: Types["String"];

  /**
   * Description text of this webinar
   */
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];

  /**
   * The URL of the webinar, the element will show a button where users
   * can click on, and they get taken to the webinar page.
   */
  @Inlet(Accepts.String) public url?: string;
}

/**
 * Webinar element shows a countdown timer and date by default to s
 */
export const WebinarDefinition = defineElement("webinar", WebinarProps, {
  versionRequired: "0.14.0",
});
